module.exports = __webpack_public_path__ + "static/media/ult-secondary-variant-lock-up-en.83ee44aa.svg";